'use client'

import { FC } from 'react'
import useCountdown from '@/hooks/useCountdown'

const CountdownTimer: FC<{ deadline?: number }> = ({ deadline }) => {
  const { isExpired, dd, hh, mm, ss } = useCountdown(deadline || 0)

  const shouldShowCountdown = deadline !== undefined && !isExpired

  if (!shouldShowCountdown) {
    return null
  }

  return (
    <div className="mt-1 flex items-center justify-center gap-0.5 font-mono text-xs">
      <span className="flex h-[18px] w-[30px] items-center justify-center rounded-sm bg-black/20 text-center text-white">
        {dd}d
      </span>
      <span className="text-white/80">:</span>
      <span className="flex h-[18px] w-[30px] items-center justify-center rounded-sm bg-black/20 text-center text-white">
        {hh}h
      </span>
      <span className="text-white/80">:</span>
      <span className="flex h-[18px] w-[30px] items-center justify-center rounded-sm bg-black/20 text-center text-white">
        {mm}m
      </span>
      <span className="text-white/80">:</span>
      <span className="flex h-[18px] w-[30px] items-center justify-center rounded-sm bg-black/20 text-center text-white">
        {ss}s
      </span>
    </div>
  )
}

export default CountdownTimer
